import './App.css';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import PriceTracker from './components/PriceTracker';
import Services from './components/Services';
import Welcome from './components/Welcome';





function App() {
  return (
    <div className="min-h-screen">

      <div className="gradient-bg-welcome">
      <Navbar />
       <Welcome/>
    
      </div>

      <PriceTracker/>

      <Services/>
     
      <Footer/>
    

    </div>
  );
}

export default App;
